"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundedButton = void 0;
const phaser_1 = __importDefault(require("phaser"));
const roundrectangle_js_1 = __importDefault(require("phaser3-rex-plugins/plugins/roundrectangle.js"));
const TextureKeys_1 = require("../constants/TextureKeys");
const Utils_1 = require("../utils/Utils");
const ColorPalette_1 = require("../constants/ColorPalette");
class RoundedButton extends phaser_1.default.GameObjects.Container {
    constructor(scene, options) {
        var _a, _b;
        super(scene, options.x, options.y);
        const scale = Utils_1.Utils.scale;
        this.options = options;
        // Draw drop-shadow
        const shadowColor = parseInt((_a = options.shadowColor) === null || _a === void 0 ? void 0 : _a.replace('#', '0x'));
        this.shadow = new roundrectangle_js_1.default(scene, 0, options.shadowOffset ? options.shadowOffset : 7 * scale, options.width, options.height, options.radius, shadowColor, options.shadowOpacity ? options.shadowOpacity : 0.2);
        // Draw radius rectangle
        const fillColor = parseInt(options.backgroundColor.replace('#', '0x'));
        this.roundBox = new roundrectangle_js_1.default(scene, 0, 0, options.width, options.height, options.radius, fillColor);
        if (options.borderWidth) {
            const borderColor = parseInt((_b = options.borderColor) === null || _b === void 0 ? void 0 : _b.replace('#', '0x'));
            this.roundBox.setStrokeStyle(options.borderWidth, borderColor);
        }
        // Draw icon
        options.iconMarginLeft |= 0;
        this.icon = scene.add.image(options.iconMarginLeft, 0, options.textureIcon, options.iconFrame);
        this.icon.setScale(options.iconScale ? options.iconScale : scale * 0.95);
        // Make rounded button can handle input
        this.setSize(options.width, options.height);
        this.setInteractive({ cursor: 'pointer' });
        // Add child elements to container
        this.add([this.shadow, this.roundBox, this.icon]);
        // Check this button has NEW LABEL or not
        this.newIcon = scene.add
            .image(0, 35 * scale, TextureKeys_1.TextureKeys.IconNew)
            .setScale(scale * 0.95);
        this.add(this.newIcon);
        if (!options.isNew) {
            this.newIcon.setVisible(false);
        }
        // Check this button has NOTIFICATION LABEL or not
        this.notificationIcon = scene.add
            .image(30 * scale, -28 * scale, TextureKeys_1.TextureKeys.IconNoti)
            .setScale(scale * 0.9);
        this.add(this.notificationIcon);
        if (!options.isNotification) {
            this.notificationIcon.setVisible(false);
        }
        scene.add.existing(this);
        Utils_1.Utils.addClickEventToObject(this.scene, this);
    }
    setEnabled(enabled) {
        const scale = Utils_1.Utils.scale;
        if (!enabled) {
            this.shadow.setVisible(false);
            this.roundBox.setFillStyle(ColorPalette_1.Colors.GreyDisabledBg);
            this.roundBox.setStrokeStyle(5 * scale, ColorPalette_1.Colors.GreyDisabledStroke);
            this.disableInteractive();
            return;
        }
        this.shadow.setVisible(true);
        const fillColor = parseInt(this.options.backgroundColor.replace('#', '0x'));
        this.roundBox.setFillStyle(fillColor);
        if (this.options.borderWidth) {
            this.roundBox.setStrokeStyle(this.options.borderWidth, ColorPalette_1.Colors[this.options.borderColor]);
        }
        else {
            this.roundBox.setStrokeStyle();
        }
        this.setInteractive();
    }
    /**
     * Hide or show new/notification mark
     * @param isNew
     * @param isNotification
     */
    setNotification(isNew, isNotification) {
        this.newIcon.setVisible(isNew);
        this.notificationIcon.setVisible(isNotification);
    }
}
exports.RoundedButton = RoundedButton;
